import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";
import {FL_PRESENTATION, FL_TYPE} from "../../../components/i18n/formLabels";
import {PH_PRESENTATION} from "../../../components/i18n/placeHolders";
import MarkdownInput from "../../../components/inputs/MarkdownInput";

const PlaceRestaurantLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            type: '',
            openFor         : '',
            concept2         : '',
            additionalInfo  : '',
            needReservation : '',
            menuPresentation: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_TYPE}
                        placeholder={FL_TYPE}
                        type="text"
                        name="type"
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={'Abierto para:'}
                        placeholder={'Abierto para:'}
                        type="text"
                        name="openFor"
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={'Concepto'}
                        placeholder={'Concepto'}
                        type="textarea"
                        name="concept2"
                        rows={'4'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_PRESENTATION}
                        placeholder={PH_PRESENTATION}
                        type="textarea"
                        name="menuPresentation"
                        rows={'2'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={'Información Adicional'}
                        placeholder={'Información Adicional'}
                        type="textarea"
                        name="additionalInfo"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default PlaceRestaurantLangs
